<template>
	<div class="sa-list-component">
		<div class="sa-list-component-body">
			<div class="b-table-sticky-header">
				<b-table sticky-header ref="table" :busy="isBusy" stacked="lg" :selectable="selectable" striped hover
					:items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left
					head-variant="light" class="sa-b-table">
					<template #cell(index)="row">
						{{ (currentPage - 1) * perPage + row.index + 1 }}
					</template>
					<template #cell(nomeArticolo)="row">
						<span style="font-weight: bold">{{ row.item.nomeArticolo }}</span>
						<span style="display: block; font-size: 0.95rem; font-style: italic">{{
							row.item.descrizioneArticolo }}</span>
					</template>
					<template #cell(giacenze)="{ item }">
						<div class="inventory-status d-flex flex-column gap-1">
							<div :class="getGiacenzaClass(item.giacenze, item.sottoscortaArticolo)"
								class="fw-bold d-flex align-items-center">
								<span>📦 {{ getGiacenzaTotale(item) }}</span>
								<font-awesome-icon v-if="item.giacenze <= item.sottoscortaArticolo"
									icon="exclamation-triangle" class="m-2 text-warning" />
							</div>
							<div class="text-muted fst-italic small-details">
								<div>
									🏗️ <b>{{ getGiacenzaFormato(item) }}</b> {{ item.descrizioneMultiplo }}
								</div>
								<div>
									🧱 <b>{{ getGiacenzaBase(item) }}</b> {{ item.descrizioneMultiploBase ?
										item.descrizioneMultiploBase : item.descrizioneMultiplo }}
								</div>
							</div>

						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<b-container class="bv-example-row">
							<b-button size="sm" v-b-tooltip.hover title="Visualizza Articolo"
								variant="outline-secondary" class="mr-1 no-text"
								@click="onClickViewArticoloMagazzino(row.item)">
								<font-awesome-icon icon="eye" />
							</b-button>
							<b-button size="sm" v-b-tooltip.hover class="mr-1 no-text" title="Modifica Articolo"
								variant="outline-success" @click="onClickModificaArticoloMagazzino(row.item)">
								<font-awesome-icon icon="edit" />
							</b-button>

							<b-button size="sm" v-b-tooltip.hover class="mr-1 no-text" title="Rimuovi Articolo"
								variant="outline-danger" @click="onClickRimuoviArticoloMagazzino(row.item)">
								<font-awesome-icon icon="trash" />
							</b-button>
						</b-container>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-list-component-invisible">
			<magazzino-articoli-anagrafica-edit-component v-if="showAnagraficaComponent"
				ref="cmpMagazzinoArticoliAnagraficaModalEdit" @articoloMagazzinoDelete="onArticoloDeleted" />
		</div>
		<div class="sa-list-component-footer">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
						size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
	</div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoArticoliAnagraficaEditComponent from "./MagazzinoArticoliAnagraficaEditComponent.vue";
export default {
	name: "MagazzinoArticoliListComponent",
	mixins: [UtilityMixin],
	components: { MagazzinoArticoliAnagraficaEditComponent },
	props: {
		selectable: { type: Boolean, default: false },
		component: { type: Boolean, default: false }
	},
	data() {
		return {
			isBusy: false,
			rows: 0,
			perPage: 50,
			currentPage: 1,
			showAnagraficaComponent: false,
			pathResource: "/magazzinoarticoli",
			linkEdit: "/magazzino/articoli",
			linkView: "/magazzino/articoli/view",
			magazzinoArticoliFilter: {},
			filtroCustom: {},
			btnAggiungi: false,
			items: [],
			filtroArticoliMagazzino: { nomeArticolo: null, codiceTipoArticolo: null, stato: null },
			selectionRows: [],
			associazione: false,
			fields: [
				{
					label: "",
					key: "index",
					sortable: true,
					thStyle: "width: 2rem",
				},
				{
					label: "Codice Articolo",
					key: "codiceArticolo",
					sortable: true,

				},
				{
					label: "Codice Prodotto",
					key: "codiceProdotto",
					sortable: true,
				},

				{
					label: "Tipo",
					key: "categoria",
					sortable: true,

				},
				{
					label: "Nome",
					key: "nomeArticolo",
					sortable: true,
				},

				{
					label: "Marca",
					key: "marca",
					sortable: true,
				},
				{
					label: "Codice Azienda",
					key: "codiceAzienda",
					sortable: true,
				},
				{
					label: "Magazzino",
					key: "magazzinoDescrizione",
					sortable: true,
				},
				{
					label: "Codice Matricola/Lotto",
					key: "lottoMatricola",
					sortable: true,
				},
				{
					label: "Giacenze",
					key: "giacenze",
					thStyle: "width: 13rem; white-space: nowrap;",
					tdClass: "text-nowrap",
					sortable: true,
				},
				{ class: "sa-table-column-action-double", key: "actions", label: "" },
			],
		};
	},
	methods: {
		init(filtro) {
			this.filtroCustom = filtro;
			this.loadDataArticoli();
		},
		getGiacenzaTotale(item) {
			return item.giacenze == 0 ? item.giacenze : item.giacenze.toFixed(1)
		},
		getGiacenzaFormato(item) {
			return item.giacenzaFormato;
		},
		getGiacenzaBase(item) {
			return item.giacenzaBase;
		},
		loadDataArticoli() {
			let me = this;
			me.$emit("beforeLoadData");
			let filtro = me.filtroCustom;
			if (!me.component) {
				if (sessionStorage["filtroMagazzino"]) {
					me.filtroArticoliMagazzino = JSON.parse(sessionStorage["filtroMagazzino"]);
				}
				filtro = { ...me.filtroArticoliMagazzino, forPage: me.perPage, page: me.currentPage };
				me.$emit("updateFilter", me.filtroArticoliMagazzino);
			}
			UtilityMixin.methods.loadDataResources(me.pathResource, filtro, me.loadDataArticoliSuccess, me.loadDataArticoliError);
		},
		loadDataArticoliSuccess(response) {
			let me = this;
			me.items = response.data.data.list;
			me.rows = response.data.data.recordsNumber;

			me.$emit("afterLoadData");
		},
		loadDataArticoliError(response) {
			let me = this;
			me.$emit("afterLoadData");
			console.error(response);
		},
		onClickRimuoviArticoloMagazzino(item) {
			let me = this;
			// ATTIVO IL COMPONENTE SOLO QUANDO SERVE
			me.showAnagraficaComponent = true;
			me.$nextTick(() => {
				me.$refs.cmpMagazzinoArticoliAnagraficaModalEdit.onDeleteArticoloMagazzino(item);
			});
		},
		onArticoloDeleted() {
			let me = this;
			me.showAnagraficaComponent = false;
			me.loadDataArticoli();
		},
		onClickViewArticoloMagazzino(item) {
			let me = this;
			// console.log("CLICK VIEW ARTICOLO [METODO]", item);
			me.$router.push("/magazzino/articoli/view/" + item.id);
		},
		onClickModificaArticoloMagazzino(item) {
			let me = this;
			me.$router.push("/magazzino/articoli/edit/" + item.id);
		},
		getGiacenzaClass(giacenza, sottoscorta) {
			return giacenza <= sottoscorta ? "text-danger font-weight-bold" : "text-success font-weight-bold";
		},
	},
	watch: {
		currentPage() {
			this.loadDataArticoli();
		},
	},
};
</script>
